import { Passage, Room } from '..';
import { Direction } from '../../../parse';
import { EntitySpec } from '../../game';
import { CanyonBottom } from '../CanyonBottom';
import { CanyonView } from '../CanyonView';

export class RockyLedge extends Room {
    static spec(): EntitySpec<RockyLedge> {
        return {
            ref: 'rocky-ledge',
            constructor: RockyLedge,
            initial: {
                contents: [
                    // TODO Cliffs
                ],
                hasBeenVisited: false,
                hasBeenDescribed: false,
            },
            nouns: [],
            adjectives: [],
            handlers: [],
        };
    }

    ref() {
        return RockyLedge.spec().ref;
    }

    name(): string {
        return 'Canyon View';
    }

    description(): string {
        return (
            'You are on a ledge about halfway up the wall of the river canyon. ' +
            'You can see from here that the main flow from Aragain Falls twists along ' +
            'a passage which it is impossible to enter. ' +
            'Below you is the canyon bottom. Above you is more cliff, ' +
            'which still appears climbable.'
        );
    }

    isNaturallyLit(): boolean {
        return true;
    }

    isSacred(): boolean {
        return true;
    }

    passages(): Passage[] {
        return [
            new Passage({
                via: Direction.Down,
                to: CanyonBottom.spec().ref,
            }),
            new Passage({
                via: Direction.Up,
                to: CanyonView.spec().ref,
            }),
        ];
    }

    hasWalls() {
        return false;
    }
}
